import React from 'react';
import { Check, CircleSlash, Icon } from '@onward-delivery/design/icons';
import { CopyableId } from '../../modals/blocks';
import { initialsFor } from '../../utils';
import { SETTING_ACTION_BUTTON, SHIPPER_AVATAR_COLORS, STATUS_ACCENT, STATUS_LABEL } from '../constants';
import { byBusinessName, deliveryProfileCardFor } from '../utils';

const HEADER_CELL = 'px-3 py-2 text-left align-middle text-[11px] font-bold uppercase text-slate-500';
const CELL = 'px-3 py-2.5 text-left align-middle text-[13px]';

// A Flex Center is the org's own location, so its delivery profile is the only setting it needs.
const FlexCenterShippers = ({ shippers, onMap }) => {
    // Grouped by settings upstream, which this table does not show, so it lists them by name instead.
    const shippersByName = [...shippers].sort(byBusinessName);

    return (
        <table className="w-full table-fixed border-collapse">
            {/* Fixed widths, so the columns line up from one Flex Center to the next. */}
            <colgroup>
                <col className="w-[30%]" />
                <col className="w-[22%]" />
                <col className="w-[26%]" />
                <col className="w-[14%]" />
                <col className="w-[8%]" />
            </colgroup>
            <thead>
                <tr className="border-b border-slate-200">
                    <th className={HEADER_CELL}>Shipper</th>
                    <th className={HEADER_CELL}>Shipper ID</th>
                    <th className={HEADER_CELL}>Delivery Profile</th>
                    <th className={HEADER_CELL}>Status</th>
                    <th className={HEADER_CELL} aria-label="Actions" />
                </tr>
            </thead>
            <tbody>
                {shippersByName.map((shipper, index) => {
                    const profileCard = deliveryProfileCardFor(shipper);
                    const avatarColor = SHIPPER_AVATAR_COLORS[index % SHIPPER_AVATAR_COLORS.length];
                    const statusTone = STATUS_ACCENT[profileCard.satisfied ? 'met' : 'missing'];
                    const statusIcon = profileCard.satisfied ? Check : CircleSlash;

                    return (
                        <tr key={shipper.client_id} className="border-b border-slate-100 last:border-0">
                            <td className={CELL}>
                                <span className="flex min-w-0 items-center gap-2">
                                    <span
                                        className={`flex size-6 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white ${avatarColor}`}
                                        aria-hidden="true"
                                    >
                                        {initialsFor(shipper.business_name)}
                                    </span>
                                    <span className="truncate font-semibold text-slate-900">
                                        {shipper.business_name}
                                    </span>
                                </span>
                            </td>
                            <td className={CELL}>
                                <CopyableId label="Shipper ID" value={shipper.client_id} />
                            </td>
                            <td className={`${CELL} truncate text-slate-500`} title={profileCard.detail}>
                                {profileCard.detail}
                            </td>
                            <td className={CELL}>
                                <span className={`${STATUS_LABEL} ${statusTone}`}>
                                    <Icon icon={statusIcon} size="sm" className="size-3 shrink-0" />
                                    {profileCard.statusLabel}
                                </span>
                            </td>
                            <td className={`${CELL} text-right`}>
                                <button
                                    type="button"
                                    onClick={() => onMap(profileCard, shipper)}
                                    aria-label={`Map ${shipper.business_name}`}
                                    className={SETTING_ACTION_BUTTON}
                                >
                                    {profileCard.actionLabel}
                                </button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default FlexCenterShippers;
